import { React, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { AiOutlineTwitter } from "react-icons/ai";
import { BiLogoPlayStore } from "react-icons/bi";
import { SiAppstore } from "react-icons/si";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import emailjs from "emailjs-com";
import {
  AiFillShopping,
  AiFillHeart,
  AiOutlineLoading3Quarters,
} from "react-icons/ai";
import logo from "../assets/Icon.png";

const Footer = ({ className = "", style = {} }) => {
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card
  );
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const [isHeaderScrolledUp, setIsHeaderScrolledUp] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      // Set isHeaderScrolledUp to true when the header is scrolled up (you can adjust the threshold)
      setIsHeaderScrolledUp(scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleSubscribe = async () => {
    setLoading(true);
    const templateId = "template_22awnz9";
    const userId = "yhpNahO4KUZ5u9Mp_";
    const emailParams = {
      to_email: "artisttie100@gmail.com",
      user_email: email,
      message: "This is a subscription request of Newsletter",
    };

    try {
      const response = await emailjs.send(
        "default_service",
        templateId,
        emailParams,
        userId
      );
      console.log("Email sent successfully!", response);

      // Clear the input field value
      setEmail("");

      setTimeout(() => {
        setLoading(false);
        toast.success("You'll be added to the newsletter.");
      }, 2000);
    } catch (error) {
      console.error("Failed to send email", error);
      setLoading(false);
      toast.error("Failed to subscribe. Please try again later.");
    }
  };

  return (
    <footer
      className={`bg-primary md:hidden sm:hidden ${className}`}
      style={style}
    >
      <div className="w-[85%] flex flex-wrap mx-auto border-b py-16 md-lg:pb-10 sm:pb-6">
        <div className="w-3/12 lg:w-4/12 sm:w-full">
          <div className="flex flex-col gap-4">
            <Link className="flex items-center gap-1" to="/">
              <img className="h-18 w-16" src={logo} alt="Logo" />
              <span className="font-[Montserrat,_sans-serif] text-[22px] text-[#ff700e] tracking-[2px] ">
                Ariz Supermart
              </span>
            </Link>
            <ul className="flex flex-col gap-2 text-slate-200">
              <li>Phone : +92 3432913865</li>
              <li>
                Email :{" "}
                <span className="text-secondary">arizsupermart@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="w-5/12 lg:w-8/12 sm:w-full">
          <div className="flex gap-9 justify-center sm:justify-start sm:mt-6 w-full">
            <div>
              <h2 className="font-bold text-slate-200 text-lg mb-2">
                CUSTOMER CARE
              </h2>
              <div className="flex justify-between gap-[80px] lg:gap-[40px]">
                <ul className="flex flex-col gap-2 text-slate-200 text-sm">
                  <li className="hover:translate-x-3 transition-transform duration-300">
                    <Link to="/about">About Us</Link>
                  </li>
                  <li className="hover:translate-x-3 transition-transform duration-300">
                    <Link to="/contact">Contact Us</Link>
                  </li>
                  {/* <li className='hover:translate-x-3 transition-transform duration-300'>
                                        <Link
                                            // to='https://artisttie-promotion.vercel.app/privacy-policy'
                                        >Privacy Policy</Link>
                                    </li>
                                    <li className='hover:translate-x-3 transition-transform duration-300'>
                                        <Link
                                            // to='https://artisttie-promotion.vercel.app/terms'
                                        >Terms and Conditions</Link>
                                    </li> */}
                </ul>
              </div>
            </div>
            <div>
              <h2 className="font-bold  text-slate-200  text-lg mb-2">
                DOWNLOAD OUR APP
              </h2>
              <div className="flex justify-between gap-[80px] lg:gap-[40px]">
                <ul className="flex flex-col gap-2 text-slate-200 text-sm">
                  <li>
                    <Link className="flex items-center gap-2 hover:translate-x-3 transition-transform duration-300">
                      {" "}
                      <BiLogoPlayStore /> Google PlayStore{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className="flex items-center gap-2 hover:translate-x-3 transition-transform duration-300">
                      <SiAppstore />
                      Iphone App store
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="w-4/12 lg:w-full lg:mt-6">
          <div className="w-full flex flex-col justify-start gap-5">
            <h2 className="font-bold  text-slate-200  text-lg mb-2">
              SUBSCRIBE OUR NEWSLETTER
            </h2>
            <span className=" text-slate-200 ">
              Get the latest offers and promotions!
            </span>
            <div className="h-[50px] w-full bg-white rounded-lg border relative">
              <input
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                placeholder="Enter your email"
                className="h-full bg-transparent w-full px-3 outline-0"
                type="text"
              />

              <button
                className="h-full absolute right-0 bg-secondary rounded-lg text-white uppercase px-4 font-bold text-sm"
                onClick={handleSubscribe}
              >
                {loading ? (
                  <div className="flex items-center ">
                    Subscribing
                    <AiOutlineLoading3Quarters className="animate-spin ml-2" />
                  </div>
                ) : (
                  "Subscribe"
                )}
              </button>
            </div>

            <ul className="flex justify-start items-center gap-3">
              <li>
                <a
                  className="w-[38px] text-[#1e2951] h-[38px] hover:bg-secondary hover:text-white flex justify-center items-center bg-white rounded-full"
                  href="/"
                >
                  <FaFacebookF />
                </a>
              </li>
              <li>
                <a
                  className="w-[38px] text-[#1e2951] h-[38px] hover:bg-secondary hover:text-white flex justify-center items-center bg-white rounded-full"
                  href="/"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li>
                <a
                  className="w-[38px] text-[#1e2951] h-[38px] hover:bg-secondary hover:text-white flex justify-center items-center bg-white rounded-full"
                  target="_blank"
                  href="https://www.instagram.com/tweaksandtucks?utm_source=qr&igsh=NTc4MTIwNjQ2YQ== "
                  rel="noreferrer"
                >
                  <FaInstagram />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="w-[85%] flex flex-wrap justify-center items-center text-slate-200 mx-auto py-5 text-center">
        <span>
          Copyright ©2024 All rights reserved | by{" "}
          <a className="text-[#ffcc00]" href="/">
            Ariz Supermart{" "}
          </a>
        </span>
      </div>

      <div
        className={`fixed translate-y-[-189%] drop-shadow-xl  md-lg:hidden w-[60px] bottom-3 h-[110px] right-2 bg-primary rounded-full  p-2 ${
          isHeaderScrolledUp ? "visible" : "invisible"
        }`}
      >
        <div className="w-full h-full flex gap-3 flex-col justify-center items-center">
          <div
            onClick={() => navigate(userInfo ? "/card" : "/login")}
            className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]"
          >
            <span className="text-xl text-orange-500">
              <AiFillShopping />
            </span>
            {card_product_count !== 0 && (
              <div className="w-[20px] h-[20px] absolute bg-primary rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                {card_product_count}
              </div>
            )}
          </div>
          <div
            onClick={() =>
              navigate(userInfo ? "/dashboard/my-wishlist" : "/login")
            }
            className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]"
          >
            <span className="text-xl text-red-500">
              <AiFillHeart />
            </span>
            {wishlist_count !== 0 && (
              <div className="w-[20px] h-[20px] absolute bg-primary rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                {wishlist_count}
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
